import React from "react"
import { capitalize } from "lodash"

import BathIcon from "@components/icons/BathIcon"
import BedIcon from "@components/icons/BedIcon"
import ReceptionIcon from "@components/icons/ReceptionIcon"
import noImg from "@images/noImage.png"
import { getPropertyURL } from "@lib/propertyUtils"
import { formatNumber } from "@lib/utils"
import { Link } from "gatsby"
import "./PropertyCard.scss"

const PropertyCardNewhomes = ({
  image,
  flag,
  price,
  priceQualifier,
  description,
  bedroom,
  bathroom,
  reception,
  displayAddress,
  department,
  status,
  slug,
  strapiID,
  imagetransforms,
  search_type,
}) => {
  const propertyURL = getPropertyURL({
    department,
    slug,
    strapiID,
    status,
    search_type,
  })

  const showInfoSection = !!(bedroom || bathroom || reception)

  let flagRibbon = ""
  let flagCls = ""
  if (flag === true) {
    flagRibbon = "Fine & Country"
    flagCls = "flag_clr"
  } else if (status === "For Sale" || status === "To Let") {
    flagRibbon = ""
  } else if (status === "Sold" || status === "Let") {
    flagRibbon = status
    flagCls = "redclr"
  } else {
    flagRibbon = status
  }

  let processedImages = imagetransforms?.images_Transforms
  processedImages ||= JSON.stringify({})

  // console.log("flag", flag, slug)
  return (
    <div className="property-card">
      {flagRibbon && <div className={`card-flag ${flagCls}`}>{flagRibbon}</div>}

      <Link className="image-section img-zoom" to={propertyURL}>
        <img
          src={image || noImg}
          alt={displayAddress}
          className="property-img"
        />
      </Link>
      <div className="content-section">
        <div className="price-section">
          <p className="price">£{formatNumber(price)}</p>
          {priceQualifier && (
            <p className="price-qualifier">{priceQualifier}</p>
          )}
        </div>
        {description && (
          <Link to={propertyURL} className="address">
            {description}
          </Link>
        )}
        {displayAddress && (
          <p className="description">{capitalize(displayAddress)}</p>
        )}
        {showInfoSection && (
          <div className="info-section-wrap">
            <div className="divider" />
            <div className="info-section">
              {!!bedroom && (
                <p className="bedrooms">
                  <BedIcon />
                  <span>{bedroom}</span>
                </p>
              )}
              {!!bathroom && (
                <p className="bathrooms">
                  <BathIcon />
                  <span>{bathroom}</span>
                </p>
              )}
              {!!reception && (
                <p className="reception">
                  <ReceptionIcon />
                  <span>{reception}</span>
                </p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default PropertyCardNewhomes
